import { memo, type ReactNode } from "react";
import { Flex, Button, Icon, Icons } from "@ir/ui";
import DeductionFilterSet from "@/presentation/deduction/components/DeductionFilter/DeductionFilterSet";
import type { FilterSetApi } from "@/presentation/deduction/components/DeductionFilter/DeductionFilterSet";

interface PromotionsToolbarProps {
  isSearchOrFilterApplied: boolean;
  filterApi: FilterSetApi;
  isRefreshing: boolean;
  onRefresh: () => void;
  onOpenFilter: () => void;
  actionsSlot?: ReactNode;
}

const PromotionsToolbar = memo(
  ({
    isSearchOrFilterApplied,
    filterApi,
    isRefreshing,
    onRefresh,
    onOpenFilter,
    actionsSlot,
  }: PromotionsToolbarProps) => (
    <Flex direction="row" align="center" justifyContent="end" wrap="no-wrap" gap={1} className="my-3">
      {isSearchOrFilterApplied && (
        <Flex direction="row" align="center" justifyContent="end" wrap="no-wrap" className="py-0 flex-1">
          <DeductionFilterSet className="w-100" groupByCheck={false} openFilter={onOpenFilter} filterApi={filterApi} />
        </Flex>
      )}

      <Button
        size="small"
        variant="clear"
        color="grey"
        isDisabled={isRefreshing}
        onPress={onRefresh}
        aria-label="Refresh promotions"
      >
        <Icon name={Icons.RefreshCw03} size="small" slot="start" className={isRefreshing ? "icon-fast-loading" : ""} />
        Refresh
      </Button>
      {actionsSlot}
    </Flex>
  )
);

PromotionsToolbar.displayName = "PromotionsToolbar";

export { PromotionsToolbar };
